import React from 'react';
import { Link } from 'react-router-dom';
import FadeIn from './FadeIn';
import { eventoRitualOutonoAtivo } from '../utils/campanhas';
import { registarEvento } from '../utils/analytics';
import { EVENTO } from '../data/evento';
import cartaz from '../assets/eventos/ritual-outono-cartaz.jpg';

// Secção da Home com o cartaz do evento. Aparece no mesmo período do pop-up (ver utils/campanhas.js).
export default function EventoDestaque() {
  if (!eventoRitualOutonoAtivo()) return null;
  return (
    <section className="py-16 px-4" style={{ backgroundColor: '#F7F5F1' }}>
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <FadeIn>
          <img
            src={cartaz}
            alt={`Cartaz: ${EVENTO.titulo}, ${EVENTO.data}`}
            width="425"
            height="638"
            loading="lazy"
            decoding="async"
            className="w-full max-w-[425px] mx-auto rounded-2xl shadow-lg"
          />
        </FadeIn>
        <FadeIn delay={100}>
          <div className="text-center md:text-left">
            <div className="inline-flex items-center gap-2 mb-3">
              <span className="h-px w-6" style={{ backgroundColor: '#B89547' }}></span>
              <span className="text-xs font-semibold tracking-[0.2em] uppercase" style={{ color: '#B89547' }}>Próximo evento</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-semibold mb-3" style={{ color: '#2E2C29' }}>{EVENTO.titulo}</h2>
            <p className="text-base mb-5" style={{ color: '#706b63' }}>{EVENTO.subtitulo}</p>
            <ul className="space-y-2 mb-6 text-sm" style={{ color: '#4a3f35' }}>
              <li>📅 {EVENTO.data}</li>
              <li>📍 {EVENTO.local}</li>
              <li>🍵 {EVENTO.extra}</li>
              <li>💛 {EVENTO.detalhes.slice(2).join(' · ')}</li>
            </ul>
            <Link
              to={EVENTO.artigo}
              onClick={() => registarEvento('clique_evento_destaque', { evento: EVENTO.chave })}
              className="inline-block px-8 py-3 rounded-full text-sm font-semibold shadow-lg transition hover:opacity-90"
              style={{ backgroundColor: '#B89547', color: '#FEFEFD' }}
            >
              Quero inscrever-me
            </Link>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
